import type React from 'react';

import { cn } from '@change/ds-utils';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useShouldShowSharingGoalFlow } from '#src/app/pages/psf/share/shared/hooks';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageFooter } from '../components/PageFooter';
import { PageState } from '../components/PageState';

import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	const { translate } = useI18n();
	const shouldShowSharingGoalFlow = useShouldShowSharingGoalFlow();

	return (
		<>
			{/* PageBanner on desktop only - on mobile it's inside parallax */}
			<div className="relative hidden md:block">
				<PageBanner />
			</div>

			<section
				aria-label={translate('corgi.psf.share.page_landmark')}
				className={cn('bg-background-overlay min-h-screen w-full md:pt-[50px]', {
					'pb-16': !shouldShowSharingGoalFlow,
					'flex flex-col': shouldShowSharingGoalFlow,
				})}
			>
				<PageState />
				<div className={cn('mx-auto max-w-[610px]', { 'flex w-full flex-1 flex-col': shouldShowSharingGoalFlow })}>
					<PageBody />
					<PageFooter />
				</div>
			</section>
		</>
	);
};
